import { Button, Form, Input, message, Alert } from "antd";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/api";
import { setToken } from "../utils/auth";
import icontecLogo from "../img/logo.png";

export default function Login() {
  const [tokenResponse, setTokenResponse] = useState(null);
  const navigate = useNavigate();
  const [animateLogo, setAnimateLogo] = useState(false);
  const [loading, setLoading] = useState(false);

  // Animación del logo al cargar
  useEffect(() => {
    setTimeout(() => setAnimateLogo(true), 300);
  }, []);

  const onFinish = async (values) => {
    setLoading(true); // 🔄 inicia loader
    try {
      const res = await api.post("/api/Authenticacion/login", values);
      const token = res.data.accessToken;
      const expiresAt = res.data.expiresAt;

      if (!token) {
        message.error("Token no recibido del API");
        setLoading(false);
        return;
      }

      setToken(token, expiresAt);
      localStorage.setItem("username", values.username);
      setTokenResponse(res.data);

      message.success("¡Bienvenido!");

      document.getElementById("loginCard").style.transform = "scale(1.05)";
      setTimeout(() => navigate("/dashboard/usuarios", { replace: true }), 400);
    } catch (err) {
      console.error(err);
      message.error("Credenciales inválidas o error en el API");
      setTokenResponse(null);
    } finally {
      setLoading(false); // ✅ apaga loader siempre
    }
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        background:
          "linear-gradient(-45deg, #faf7f7ff, #11c9eeff, #21699cff, #4d78d5ff)",
        backgroundSize: "400% 400%",
        animation: "gradientAnimation 15s ease infinite",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <style>
        {`
          @keyframes gradientAnimation {
            0% {background-position: 0% 50%;}
            50% {background-position: 100% 50%;}
            100% {background-position: 0% 50%;}
          }
        `}
      </style>

      <div
        id="loginCard"
        style={{
          width: 400,
          backgroundColor: "rgba(255,255,255,0.95)",
          padding: 40,
          borderRadius: 20,
          boxShadow: "0 20px 40px rgba(0,0,0,0.2)",
          textAlign: "center",
          transform: "scale(0.95)",
          transition: "all 0.4s ease",
        }}
      >
        <img
          src={icontecLogo}
          alt="ICONTEC"
          style={{
            width: 120,
            marginBottom: 20,
            opacity: animateLogo ? 1 : 0,
            transform: animateLogo ? "translateY(0)" : "translateY(-30px)",
            transition: "all 0.6s ease",
          }}
        />

        <h2 style={{ color: "#0099feff", marginBottom: 30 }}>
          Acceso ICONTEC eBooks
        </h2>

        <Form layout="vertical" onFinish={onFinish}>
          <Form.Item
            name="username"
            rules={[{ required: true, message: "Ingrese su usuario" }]}
          >
            <Input
              placeholder="Usuario"
              style={{
                borderRadius: 12,
                height: 45,
                padding: "0 15px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#007bffff")}
              onBlur={(e) => (e.target.style.borderColor = "#ccc")}
            />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: "Ingrese su contraseña" }]}
          >
            <Input.Password
              placeholder="Contraseña"
              style={{
                borderRadius: 12,
                height: 45,
                padding: "0 15px",
                border: "1px solid #ccc",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
              }}
              onFocus={(e) => (e.target.style.borderColor = "#3662f4ff")}
              onBlur={(e) => (e.target.style.borderColor = "#ccc")}
            />
          </Form.Item>

          <Button
            type="primary"
            htmlType="submit"
            block
            loading={loading}
            disabled={loading}
            style={{
              backgroundColor: "#369ef4ff",
              borderColor: "#367ff4ff",
              borderRadius: 12,
              height: 45,
              fontWeight: "bold",
              fontSize: 16,
              marginTop: 10,
              boxShadow: "0 5px 15px rgba(0,0,0,0.2)",
              transition: "all 0.3s ease",
            }}
          >
            {loading ? "Validando..." : "Ingresar"}
          </Button>
        </Form>
      </div>
    </div>
  );
}
